import React from 'react';
import GeoMetricInfoIcon from './GeoMetricInfoIcon';

/** Table column header with optional metric definition tooltip. */
export default function GeoTableHeaderLabel({ children, metricKey, tooltip }) {
  return (
    <span className="geo-table-header-label">
      <span>{children}</span>
      <GeoMetricInfoIcon
        metricKey={metricKey}
        text={tooltip}
        title={typeof children === 'string' ? children : undefined}
        className="geo-metric-info geo-metric-info--compact"
      />
    </span>
  );
}
